export default __webpack_public_path__ + "94042a6f999c620b8aee4b3659e4954e.png";